/**
 * Created by shubham on 8/5/18.
 */

import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../../config';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DialogComponent } from '../../../dialog/dialog.component';
import {TranslateService} from 'ng2-translate';


@Component({
    selector: 'view-admin',
    template: require('./viewAdmin.component.html')
})
export class ViewAdminComponent {

    dialogRef;
    userDetails: any;
    id: any;
    AdminEditForm: FormGroup;
    AdminEditFormDetails: any;
    adminDetails = [];
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    isDisabled = true;
    adminRoles = [];
    selectedItems = [];
    settings = {};

    constructor(private router: Router,private route: ActivatedRoute, private sessionHandler:SessionHandler, public httpService : HttpService, 
        public dialog: MdDialog, private formBuilder: FormBuilder, private translate: TranslateService) {

        this.route.params.subscribe(params => {
            this.id = +params['id'];
        });

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        if(this.isSystemAdmin){
            this.getAdminDataById(this.id);
            this.getAdminRoles();
        } else{
            //TODO
        }
    }

    public getAdminRoles(){
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(
            res => { this.saveAdminRoles(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveAdminRoles(res){
        if(res && res.items){
            this.adminRoles = res.items;
        }
        this.httpService.onEnd();
    }

    public getAdminDataById(id){
        this.httpService.getRequest('superUserOperationsApi/v1/admin/'+ id).subscribe(
            res => { this.saveRequestData(res) },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveRequestData(res) {
        if(res){
            this.adminDetails = res;
            if(this.adminDetails['roleId'] && this.adminDetails['roleName']){
                for(let l in this.adminDetails['roleId']){
                    this.selectedItems.push({id: this.adminDetails['roleId'][l], name: this.adminDetails['roleName'][l]});
                }
            }
            this.AdminEditFormDetails = this.adminDetails;
            this.buildForm();
            this.httpService.onEnd();
        } else if(res.errorStatus == 'Fail'){
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }

    buildForm() {
        this.AdminEditForm = this.formBuilder.group({
            roleData: this.formBuilder.control(null, [Validators.required]),
        });
        this.AdminEditForm.valueChanges.subscribe(data => {
            this.AdminEditFormDetails = this.AdminEditForm.getRawValue();
            this.AdminEditFormDetails['id'] = this.adminDetails['id'];

            this.AdminEditFormDetails['roleId'] = [];
            for (let d in this.AdminEditFormDetails.roleData){
                this.AdminEditFormDetails['roleId'].push(this.AdminEditFormDetails.roleData[d]['id']);
            }
            this.AdminEditFormDetails.validate = this.AdminEditForm.valid;
        });
    }

    public saveAdminRole(){
        this.httpService.postRequest(this.AdminEditFormDetails,'superUserOperationsApi/v1/updateAdminRole').subscribe(
            res => { this.saveAdminEditResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveAdminEditResponse(res){
        if(res){
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "Role Updated Successfully";
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/manage-admin/list';
            });
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    }
    api1:boolean = true;
    buroleSelect(item: any){
        console.log(item);
        
        if(this.selectedItems.find(x=> x.id == "5639445604728832")){
        
            if(this.api1){
                /* this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = "This user id is not able to assign manager"; */
            }  
        }
        else{
            /* if(this.selectedAdminItems.find(x=> x.id == "5639445604728832")){
               var sliceFor =  this.selectedAdminItems.findIndex(x=> x.id == "5639445604728832");
                this.selectedAdminItems.splice(sliceFor);
            } */
           
        }
    }

    ngOnInit() {
        this.buildForm();

        var temp_settings = {singleSelection: false,text:"",labelKey: "name",selectAllText:"",unSelectAllText:"",classes:"myclass custom-class"};
        this.translate.get('Select Role').subscribe((res: string) => {temp_settings.text = res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
        this.translate.get('select_all').subscribe((res: string) => {temp_settings.selectAllText=res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
        this.translate.get('unselect_all').subscribe((res: string) => {temp_settings.unSelectAllText=res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/viewAdmin/viewAdmin.component.ts